function set_menu_style(menu_style) {

    let header_element = document.getElementById('header-component');

    switch (menu_style) {
        case 'drawer':
            header_element.dataset.menuStyle = 'drawer';
        break;
        case 'menu':
            header_element.dataset.menuStyle = 'drawer';
        break;
    }
}

window.addEventListener('load', () => {
    set_menu_style('drawer');
});

window.addEventListener('resize', () => {
    setTimeout(() => {
        set_menu_style('drawer');
    }, 500);
});